import { render, staticRenderFns } from "./AssignMerchant.vue?vue&type=template&id=69689e59&"
import script from "./AssignMerchant.vue?vue&type=script&lang=js&"
export * from "./AssignMerchant.vue?vue&type=script&lang=js&"
import style0 from "./AssignMerchant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports